import { createApiClient } from "@/api";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/payment_provider_models";

export const fetchPaymentProviderModelsListData = async () => {
  const { data = [] } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  return {
    data,
    total: data.length,
  };
};
